import { useQuery } from "@tanstack/react-query";
import type { AppConfigAuditView } from "@/lib/api/types";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { queryKeys } from "@/lib/query/core/query-keys";

export function useAppConfigAuditQuery(key: string, enabled: boolean) {
  const query = useQuery({
    queryKey: queryKeys.admin.appConfigAudit(key),
    queryFn: () =>
      apiJsonClient<AppConfigAuditView[]>(endpoints.admin.appConfigAudit(key)),
    enabled,
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    error: query.error,
  };
}
